import SharedFlightInfo from './SharedFlightInfo';

export default SharedFlightInfo;
